<template>
  <div class="plate-type">
    <div class="solution-banner">
      <img src="@/assets/images/website/solution/plate-type/banner.png" />
    </div>
    <div class="plate-type-control-system">
      <div class="website-container">
        <h2>板型检测及控制系统</h2>
        <div class="control-system-introduce">
          <img alt src="@/assets/images/website/solution/plate-type/dot.png" />
          <span>板形测量-控制系统由两部分组成</span>
        </div>
        <div class="control-system-introduce">
          <img alt src="@/assets/images/website/solution/plate-type/dot.png" />
          <span>板形仪，也称为板形辊，是板形测量-控制系统的“眼睛”</span>
        </div>
        <div class="control-system-introduce">
          <img alt src="@/assets/images/website/solution/plate-type/dot.png" />
          <span>板形控制系统，是板形测量-控制系统的 “大脑”</span>
        </div>
        <img class="control-system-introduce-pic" src="@/assets/images/website/solution/plate-type/part_1_1.png" />
        <img class="control-system-introduce-pic" src="@/assets/images/website/solution/plate-type/part_1_2.png" />
      </div>
    </div>
    <div class="heating-system">
      <div class="website-container">
        <h2>工作辊电磁感应加热系统</h2>
        <div class="heating-system-introduce">
          <img alt src="@/assets/images/website/solution/plate-type/dot.png" />
          <span>有效解决带材边部板形问题</span>
        </div>
        <div class="heating-system-introduce">
          <img alt src="@/assets/images/website/solution/plate-type/dot.png" />
          <span>边部板形好，生产稳定，提高了轧制速度和生产效率</span>
        </div>
        <div class="heating-system-introduce">
          <img alt src="@/assets/images/website/solution/plate-type/dot.png" />
          <span>减小废边宽度，减小下游切边量，提高成材率</span>
        </div>
        <div class="heating-system-introduce">
          <img alt src="@/assets/images/website/solution/plate-type/dot.png" />
          <span>部分产品，甚至可取消拉矫工序，直接缩短生产流程，降低成本</span>
        </div>
        <div class="heating-system-pic">
          <img class="heating-system-pic-top-left" src="@/assets/images/website/solution/plate-type/part_2_1.png" />
          <img class="heating-system-pic-top-right" src="@/assets/images/website/solution/plate-type/part_2_2.png" />
        </div>
        <div>
          <img class="heating-system-pic-bottom-left" src="@/assets/images/website/solution/plate-type/part_2_3.png" />
          <img class="heating-system-pic-bottom-middle" src="@/assets/images/website/solution/plate-type/part_2_4.png" />
          <img class="heating-system-pic-bottom-right" src="@/assets/images/website/solution/plate-type/part_2_5.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {}
</script>
<style lang="less" scoped>
.solution-banner {
  width: 100%;
  img {
    width: 100%;
    object-fit: cover;
  }
}
.plate-type-control-system {
  padding: 30px 0;
  h2 {
    line-height: 40px;
    margin: 10px 0 20px 0;
  }
  .control-system-introduce {
    line-height: 28px;
    margin: 4px 0;
    img {
      padding-right: 6px;
    }
  }
  .control-system-introduce-pic {
    width: 100%;
    margin: 10px 0;
  }
}
.heating-system {
  background: linear-gradient(#f6f7f9, #ffffff);
  padding: 30px 0;
  h2 {
    line-height: 40px;
    margin: 10px 0 20px 0;
  }
  .heating-system-introduce {
    line-height: 28px;
    margin: 4px 0;
    img {
      padding-right: 6px;
    }
  }
  .heating-system-pic {
    margin: 16px 0;
  }
  .heating-system-pic-top-left {
    width: 550px;
    height: 520px;
    margin-right: 20px;
  }
  .heating-system-pic-top-right {
    height: 520px;
  }
  .heating-system-pic-bottom-left {
    width: 650px;
    height: 430px;
  }
  .heating-system-pic-bottom-middle {
    width: 320px;
    height: 430px;
  }
  .heating-system-pic-bottom-right {
    width: 310px;
    height: 430px;
  }
}
</style>
